// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"58c7e80c","170":"7ce847e1","244":"3ae52eed","664":"ad5c751f"}[chunkId] + ".chunk.js";
};